module.exports = __webpack_public_path__ + "img/JM_LOGO.7c3218b0.png";